import React from 'react'; 
import {logger} from '../logger';
import { DateFormats } from "../enums/DateFormat";
import moment from 'moment';


export const DateDisplay = (props:{date:string|null|undefined, format:DateFormats, isTextBold: boolean })=>{

    let formatter = new Intl.DateTimeFormat('en-GB');

    if (props.format === DateFormats.MMYYYY) {
        formatter = new Intl.DateTimeFormat('en-GB',{ month: 'short', year: 'numeric' });
    }

    try{
      let displayDate = props.date
      ? props.format === DateFormats.DDMMMYYYYHyphen
        ? moment(props.date).format("DD-MMM-YYYY")
        : formatter.format(new Date(props.date))
      : null;

        if (props.isTextBold){
            return <><b>{displayDate}</b></>
        }
        return <>{displayDate}</>
    }catch(err){
        logger.error(err);
        return null;
    }
};

export const DateConverter = (date: string) => {
    try {
      let formatter = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
      return formatter.format(new Date(date));
    } catch (error) {
      return "";
    }
  };

  export const DateFormatter = (format:string, date: string) => {
    try {
      return moment(date).format(format);
    } catch (error) {
      return "";
    }
  };
